import AppSharedNotFound from "../../../src/shared-view/app/not-found/app";
import {ITEM_VIEW_ATTACHMENT_PREVIEW, ITEM_VIEW_DOCUMENT, ITEM_VIEW_TASK} from "core/gd/app-manager/item-view";
import AppRequestForm from "../../../src/shared-view/app/request-form"
import SharedViewAppLoader from "../../../src/shared-view/app/app-loader"

// const gd = require('ampersand-app');
const Router = require('ampersand-router');

module.exports = Router.extend({

    routes: {
        'request(/:id)': 'requestForm',

        ':id': 'sharedView',
        ':id/t(/:taskId)(/:messageId)': 'sharedTask',
        ':id/n(/:noteId)': 'sharedDoc',

        // 'shared-view(/:id)': 'sharedView',
        // 'shared-view(/:id)/t(/:taskId)(/:messageId)': 'sharedTask',
        // 'shared-view(/:id)/n(/:noteId)': 'sharedDoc',

        'a(/:type)(/:storageProvider)(/:fileId)': 'attachmentPreview',

        '(*path)': 'catchAll'
    },

    requestForm(id) {
        gd.appManager.launchApp(AppRequestForm,{publicKey:id});
    },

    sharedView(id, forcePushUrl) {
        return gd.appManager.loadAndRun(SharedViewAppLoader,{publicKey:id, forcePushUrl});
    },

    sharedTask(id, taskId, messageId) {
        const loadTaskApp = () => {gd.appManager.loadAndRunItemView(require('shared-view/app/task/app-loader'),{publicKey:id, taskId, messageId, containerId: ITEM_VIEW_TASK});}

        if (!gd.app) this.sharedView(id, id).done(loadTaskApp); // load background app first
        else loadTaskApp();
    },

    sharedDoc(id, docId) {
        const loadTaskApp = () => {gd.appManager.loadAndRunItemView(require('shared-view/app/document/app-loader'),{publicKey:id, docId, containerId: ITEM_VIEW_DOCUMENT});}

        if (!gd.app) this.sharedView(id, id).done(loadTaskApp); // load background app first
        else loadTaskApp();
    },

    attachmentPreview(type, storageProvider, fileId) {
        switch (type) {
            case 'i': gd.appManager.loadAndRunItemView(require('app/attachment-preview/app-loader'), {
                type: type,
                fileId: fileId,
                storageProvider: storageProvider,
                containerId: ITEM_VIEW_ATTACHMENT_PREVIEW
            });
        }
    },

    catchAll(path) {
        console.log("Router catch all", path);
        gd.appManager.launchApp(AppSharedNotFound,{});
    },
});